export default "__VITE_ASSET__CqyTlAcD__"